import * as Yup from 'yup';

export const SetupEmailFormValidationSchema = Yup.object().shape({
  RecruiterID: Yup.object()
    .nullable()
    .required('This field is required'),

  Subject: Yup.string()
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .required('This field is required'),

  Message: Yup.object()
    .test(
      'is-empty',
      'This field is required',
      value => value && value.getCurrentContent().hasText()
    )
    .test(
      'max-length',
      'You have exceeded the maximum number of 10000 characters',
      value => value && value.getCurrentContent().getPlainText().length <= 10000
    ),

  attachSize: Yup.number().required(),

  attachments: Yup.array().when(['attachSize'], (attachSize, schema) =>
    schema.of(
      Yup.object()
        .test(
          'overallSize',
          'The overall size of files is too big. Max size for all files is 6MB',
          () => 1024 * 1024 * 6 > attachSize
        )
        .test(
          'maxSize',
          'The file is too big. Max file size is 5MB',
          value => value.file.size <= 5 * 1024 * 1024
        )
    )
  ),
});
